import React from 'react';
import { Box, Divider, AbsoluteCenter, Text, Link } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { formatDate, toTitleCase } from '../../utils/helpers';

const StationInfo = (props) => {
    const { metadata, datasetId } = props;

    const stationInfo = {};

    const latitudeRow = metadata.find((r) =>
        r["Row Type"] === "attribute"
        && r["Variable Name"] === "latitude"
        && r["Attribute Name"] === "actual_range"
    );

    const longitudeRow = metadata.find((r) =>
        r["Row Type"] === "attribute"
        && r["Variable Name"] === "longitude"
        && r["Attribute Name"] === "actual_range"
    );

    const stationType = metadata.find((r) =>
        r["Row Type"] === "attribute"
        && r["Variable Name"] === "station"
        && r["Attribute Name"] === "type"
    );

    const creatorName = metadata.find((r) =>
        r["Row Type"] === "attribute"
        && r["Variable Name"] === "NC_GLOBAL"
        && r["Attribute Name"] === "creator_name"
    );

    const creatorUrl = metadata.find((r) =>
        r["Row Type"] === "attribute"
        && r["Variable Name"] === "NC_GLOBAL"
        && r["Attribute Name"] === "creator_url"
    );

    const publisherName = metadata.find((r) =>
        r["Row Type"] === "attribute"
        && r["Variable Name"] === "NC_GLOBAL"
        && r["Attribute Name"] === "publisher_name"
    );

    const publisherUrl = metadata.find((r) =>
        r["Row Type"] === "attribute"
        && r["Variable Name"] === "NC_GLOBAL"
        && r["Attribute Name"] === "publisher_url"
    );

    const rawContributorName = metadata.find((r) =>
        r["Row Type"] === "attribute"
        && r["Variable Name"] === "NC_GLOBAL"
        && r["Attribute Name"] === "contributor_name"
    );

    const contributorName = rawContributorName.Value.split(",");

    const rawContributorUrl = metadata.find((r) =>
        r["Row Type"] === "attribute"
        && r["Variable Name"] === "NC_GLOBAL"
        && r["Attribute Name"] === "contributor_url"
    );

    const contributorUrl = rawContributorUrl.Value.split(",");

    const rawContributorRole = metadata.find((r) =>
        r["Row Type"] === "attribute"
        && r["Variable Name"] === "NC_GLOBAL"
        && r["Attribute Name"] === "contributor_role"
    );

    const contributorRole = rawContributorRole.Value.split(",");

    stationInfo.latitude = latitudeRow.Value.split(",")[1].trim();
    stationInfo.longitude = longitudeRow.Value.split(",")[1].trim();
    stationInfo.station_type = stationType.Value;
    stationInfo.creatorName = creatorName.Value;
    stationInfo.creatorUrl = creatorUrl.Value;
    stationInfo.publisherName = publisherName.Value;
    stationInfo.publisherUrl = publisherUrl.Value;
    stationInfo.contributors = [];

    for (let i = 0; i < contributorName.length; i++) {
        stationInfo.contributors[i] = {
            Name: contributorName[i],
            Url: contributorUrl[i],
            Role: contributorRole[i]
        };
    }

    stationInfo.timeCoverageStart = metadata.find((r) =>
        r["Row Type"] === "attribute"
        && r["Attribute Name"] === "time_coverage_start"
    )?.Value;

    stationInfo.timeCoverageEnd = metadata.find((r) =>
        r["Row Type"] === "attribute"
        && r["Attribute Name"] === "time_coverage_end"
    )?.Value;

    const stationErddapUrl = `https://erddap.aoos.org/erddap/info/${datasetId}/index.html`;

    return (
        <Box display={'flex'} flexDirection={'column'} padding={5} textAlign='left'>
            <Box mb={10}>
                <Text fontWeight={'bold'}>Location</Text>
                <Text>{stationInfo.latitude}, {stationInfo.longitude}</Text>
            </Box>

            <Box mb={10}>
                <Text fontWeight={'bold'}>Temporal Coverage</Text>
                <Text>{formatDate(stationInfo.timeCoverageStart)} &nbsp;&mdash;&nbsp; {formatDate(stationInfo.timeCoverageEnd)}</Text>
            </Box>

            <Box mb={10}>
                <Text fontWeight={'bold'}>Station Type</Text>
                <Text>{toTitleCase(stationInfo.station_type)}</Text>
            </Box>

            <Box mb={10}>
                <Text fontWeight={'bold'}>Metadata</Text>
                <Link href={stationErddapUrl}>ERDDAP Station Page</Link>
            </Box>

            <Box mb={10}>
                <Text fontWeight={'bold'}>URN</Text>
                <Text>{datasetId}</Text>
            </Box>

            <Box position='relative' py={10}>
                <Divider />
                <AbsoluteCenter bg={'gray.50'} px='4' textColor={'gray.400'} marginBottom={20}>Affiliations</AbsoluteCenter>
            </Box>

            <Box display="flex" alignItems="center">
                <Text fontWeight="bold" flex="1">
                    {stationInfo.creatorName}
                </Text>
                <Text flex="1" marginLeft={{ base: 10, md: -5 }}>Creator</Text>
                <Link href={stationInfo.creatorUrl} flex="0">
                    <Box display="flex" alignItems={'center'}>
                        Site
                        <ExternalLinkIcon marginLeft={1} />
                    </Box>
                </Link>
            </Box>

            <Divider marginY={10} />

            <Box display="flex" alignItems="center">
                <Text fontWeight="bold" flex="1">
                    {stationInfo.publisherName}
                </Text>
                <Text flex="1" marginLeft={{ base: 10, md: -5 }}>Publisher</Text>
                <Link href={stationInfo.publisherUrl} flex="0">
                    <Box display="flex" alignItems={'center'}>
                        Site
                        <ExternalLinkIcon marginLeft={1} />
                    </Box>
                </Link>
            </Box>

            <Divider marginY={10} />

            {stationInfo.contributors.map((contributor, index) => (
                <Box key={index}>
                    <Box display="flex" alignItems="center" key={index}>
                        <Text fontWeight="bold" flex="1">
                            {contributor.Name}
                        </Text>
                        <Text flex="1" marginLeft={{ base: 10, md: -5 }}>
                            {toTitleCase(contributor.Role)}
                        </Text>
                        <Link href={contributor.Url} flex="0">
                            <Box display="flex" alignItems={'center'}>
                                Site
                                <ExternalLinkIcon marginLeft={1} />
                            </Box>
                        </Link>
                    </Box>
                    <Divider marginY={10} />
                </Box>
            ))}
        </Box>
    );
};

export default StationInfo;
